import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useFetch from "../../context/useFetch";
import { toast } from "react-toastify";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// import JS files
import MuiTextField from "../shares/MuiTextField";
import MuiButton from "../shares/MuiButton";

const ForgotPasswordOtp = (props) => {
  const navigate = useNavigate();

  const { state } = useLocation();
  const [otp, setOtp] = useState();
  const [timeLeft, setTimeLeft] = useState(120);

  useEffect(() => {
    if (state == null) navigate("/forgot-password");
  }, []);

  useEffect(() => {
    if (!timeLeft) return;
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const PostOtpCodeApi = useFetch({
    method: "post",
    url: "user/check_auth_code",
    data: {
      phone: state !== null ? state.phone : undefined,
      code: otp,
    },
    trigger: false,
    noHeader: true,
    argFunc: (res) => {
      if (res.data == "ok")
        navigate("/newPassword", {
          state: {
            phone: state !== null ? state.phone : undefined,
          },
        });
      else
        toast.error("کد وارد شده نادرست می باشد ", {
          position: toast.POSITION.TOP_CENTER,
        });
    },
    errMessage: (mess) => {},
  });
  const PostResendOtpCodeApi = useFetch({
    url: "user/check_user",
    method: "POST",
    data: {
      phone: state !== null ? state.phone : undefined,
    },
    trigger: false,
    noHeader: true,
    argFunc: (res) => setTimeLeft(120),
  });
  const handleResendOtpCode = () => {
    PostResendOtpCodeApi.reFetch();
  };

  return (
    <>
      <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
        <div className="mx-auto	 w-10/12 sm:w-auto relative py-3 sm:max-w-xl sm:mx-auto">
          <div className="absolute inset-0 bg-gradient-to-r from-myblue-100 to-myblue-100 shadow-lg transform -skew-y-6 sm:skew-y-0 -rotate-6 rounded-3xl"></div>
          <div className="mx-auto relative px-4 py-10 bg-white shadow-lg rounded-3xl sm:p-20">
            <div className="max-w-md mx-auto">
              <div className="mb-6 back-icon">
                <ArrowForwardIcon onClick={() => navigate(-1)} />
              </div>
              <div className="flex justify-center">
                <h1 className="text-base md:text-2xl font-semibold">
                  کد تایید را وارد کنید
                </h1>
              </div>
              <div class="mt-3">
                <span className="text-xs sm:text-base">
                  کد تایید پیامک شده را وارد نمایید.
                </span>
              </div>
              <div className="divide-y divide-gray-200">
                <div className="text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                  <div className="mt-4">
                    <MuiTextField
                      id="otp_number"
                      label="کد تایید"
                      variant="outlined"
                      size="small"
                      isLTR={true}
                      type="number"
                      onChange={(e) => setOtp(e.target.value)}
                      value={otp !== null ? otp : ""}
                    />
                  </div>
                  <div>
                    <MuiButton
                      onClick={() =>
                        timeLeft > 0
                          ? PostOtpCodeApi.reFetch()
                          : handleResendOtpCode()
                      }
                      variant="contained"
                      color="primary"
                      text={timeLeft == 0 ? "ارسال مجدد" : "تایید"}
                      htmlType="submit"
                      disabled={otp == undefined && timeLeft>0}
                      isFullWidth={true}
                    />
                  </div>
                  {timeLeft > 0 && (
                    <div className="mt-2 text-sm flex justify-center">
                      <span>
                        ارسال مجدد کد پس از <span className="text-sky-500">{timeLeft}</span> ثانیه
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordOtp;
